import { addDays, endOfDay, isBefore } from 'date-fns';

import type { DateRange } from './types';

export function clampDateRange(value: DateRange, now: Date): DateRange {
  const to = value.to
    ? isBefore(value.to, endOfDay(now))
      ? value.to
      : now
    : undefined;

  const from = value.from
    ? isBefore(value.from, to ?? now)
      ? value.from
      : addDays(to ?? now, -7)
    : undefined;

  return { from, to };
}
